import createHttpClient from './httpClient'

const baseUrl = new URL('/api/v1/resources/integration-sync-check', process.env.VUE_APP_INTERNAL_SERVICE_BASE_URL).href

const httpClient = createHttpClient(baseUrl)

const IntegrationSyncCheckApi = {
  getAll() {
    return httpClient.get('/')
  },

  getByType(integrationType) {
    return httpClient.get(`/${integrationType}`)
  },

  getHistory(integrationType, limit = 10) {
    return httpClient.get(`/${integrationType}/history`, {
      params: { limit }
    })
  }
}

export default IntegrationSyncCheckApi
